import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class EmployeeShortHourDetailDto implements IEmployeeShortHourDetailDto {
    employee!: EmployeeSummaryDto;
    timings!: string | undefined;
    empLegalName!: string | undefined;
    eventDate!: Date | undefined;
    inTime!: Date | undefined;
    outTime!: Date | undefined;
    presentTime!: string | undefined;
    absentTime!: string | undefined;

    constructor(data?: IEmployeeShortHourDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.timings = _data["timings"];
            this.empLegalName = _data["empLegalName"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.presentTime = _data["presentTime"];
            this.absentTime = _data["absentTime"];
        }
    }

    static fromJS(data: any): EmployeeShortHourDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeShortHourDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["timings"] = this.timings;
        data["empLegalName"] = this.empLegalName;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["presentTime"] = this.presentTime;
        data["absentTime"] = this.absentTime;
        return data; 
    }
}

export interface IEmployeeShortHourDetailDto {
    employee: EmployeeSummaryDto;
    timings: string | undefined;
    empLegalName: string | undefined;
    eventDate: Date | undefined;
    inTime: Date | undefined;
    outTime: Date | undefined;
    presentTime: string | undefined;
    absentTime: string | undefined;
}

